import { EndPoints } from "../api-config";
let SERVER_ADDR_V1 = EndPoints.backendHost;

export const searchCityOrPostalCode = (search, id) => (id ? `${SERVER_ADDR_V1}/PostalCode/search?textSearch=${search}&id=${id}` : `${SERVER_ADDR_V1}/PostalCode/search?textSearch=${search}`);
